// @flow

import React from 'react';
export function AIIcon() {
  const linearGradientId00 = `paint0_linear_2026_6913_${Math.random()}`;
  const linearGradientId01 = `paint1_linear_2026_6913_${Math.random()}`;
  const clipPathId = `clip0_2026_6913_${Math.random()}`;
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.05" width="20" height="20" rx="10" fill="#F04458" />
      <rect
        opacity="0.2"
        x="0.833252"
        y="0.833252"
        width="18.3333"
        height="18.3333"
        rx="9.16667"
        fill="#F04458"
      />
      <rect
        x="1.66675"
        y="1.66675"
        width="16.6667"
        height="16.6667"
        rx="8.33333"
        fill={`url(#${linearGradientId00})`}
      />
      <rect
        x="0.833415"
        y="0.833415"
        width="18.3333"
        height="18.3333"
        rx="9.16667"
        stroke={`url(#${linearGradientId01})`}
        strokeOpacity="0.3"
        strokeWidth="1.66667"
      />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M8.74967 5L9.78081 6.88553L11.6663 7.91667L9.78081 8.94781L8.74967 10.8333L7.71854 8.94781L5.83301 7.91667L7.71854 6.88553L8.74967 5Z"
          fill="white"
        />
        <path
          d="M12.9163 9.16675L13.653 10.5134L14.9997 11.2501L13.653 11.9867L12.9163 13.3334L12.1797 11.9867L10.833 11.2501L12.1797 10.5134L12.9163 9.16675Z"
          fill="white"
        />
        <path
          d="M8.74976 12.5L9.19176 13.308L9.99976 13.75L9.19176 14.192L8.74976 15L8.30776 14.192L7.49976 13.75L8.30776 13.308L8.74976 12.5Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id={linearGradientId00}
          x1="1.66675"
          y1="10.0843"
          x2="23.7816"
          y2="10.5496"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C830E1" />
          <stop offset="1" stopColor="#FE4A25" />
        </linearGradient>
        <linearGradient
          id={linearGradientId01}
          x1="1.66675"
          y1="10.0843"
          x2="23.7816"
          y2="10.5496"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C830E1" />
          <stop offset="1" stopColor="#FE4A25" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="10" height="10" fill="white" transform="translate(5.4165 5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function MagicIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2026_8205)">
        <path
          d="M7 1L8.85605 4.39395L12.25 6.25L8.85605 8.10605L7 11.5L5.14395 8.10605L1.75 6.25L5.14395 4.39395L7 1Z"
          fill="url(#paint0_linear_2026_8205)"
        />
        <path
          d="M14.5 8.5L15.826 10.924L18.25 12.25L15.826 13.576L14.5 16L13.174 13.576L10.75 12.25L13.174 10.924L14.5 8.5Z"
          fill="url(#paint1_linear_2026_8205)"
        />
        <path
          d="M7 14.5L7.7956 15.9544L9.25 16.75L7.7956 17.5456L7 19L6.2044 17.5456L4.75 16.75L6.2044 15.9544L7 14.5Z"
          fill="url(#paint2_linear_2026_8205)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2026_8205"
          x1="2.22727"
          y1="4.0625"
          x2="9.24009"
          y2="11.2347"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C830E1" />
          <stop offset="1" stopColor="#FE4A25" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2026_8205"
          x1="11.0909"
          y1="10.6875"
          x2="16.1001"
          y2="15.8105"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C830E1" />
          <stop offset="1" stopColor="#FE4A25" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2026_8205"
          x1="4.95455"
          y1="15.8125"
          x2="7.96004"
          y2="18.8863"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C830E1" />
          <stop offset="1" stopColor="#FE4A25" />
        </linearGradient>
        <clipPath id="clip0_2026_8205">
          <rect width="18" height="18" fill="white" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </svg>
  );
}
